import gql from 'graphql-tag';

export const SET_AVATAR_DATA_MUTATION = gql`
  mutation SetAvatarData($input: SetAvatarDataInput!) {
    setAvatarData(input: $input)
  }
`;
